import { render, staticRenderFns } from "./PickPositions.vue?vue&type=template&id=16abf33a&"
import script from "./PickPositions.vue?vue&type=script&lang=js&"
export * from "./PickPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports